import { Autocomplete, Box, Checkbox, CircularProgress, FormControl, FormControlLabel, InputLabel, SxProps, Theme } from "@mui/material";
import { GetAutocompleteResult } from "hooks/work-items/useWorkItemAutocompleteResource";
import { useState } from "react";
import { WorkItemTextField } from "../shared/WorkItemInputStyles";
import { BulkUpdateModes } from "../WorkItemBulkUpdate";

interface IWorkItemSearchFieldResourceProps {
    idSuffix: string,
    resources: GetAutocompleteResult[] | null,
    onChange: (e: any, newValue: string | GetAutocompleteResult | null) => void
    onKeyUp: (e: any) => void,
    loadingResources: boolean,
    errorResources: string | null,
    onChangeCheckbox: () => void,
    mode: BulkUpdateModes,
    isPrimaryChecked?: boolean,
    onChangeIsPrimaryCheckbox?: (e: any) => void,
    label?: string  | null,
    labelProps?: SxProps<Theme> | undefined
}

const ForwardWorkItemInputField = (props: any) => {    
    return (
        <FormControl
            sx={{ paddingRight: 1 }}
            variant="standard" fullWidth>
            <InputLabel
                sx={props.labelProps}
                shrink htmlFor="work-item-input-field">
                {props.labelText || "Resource"}:
            </InputLabel>
            <WorkItemTextField
                id="work-item-input-field"
                fullWidth
                ref={(input) => {
                    if (props.ref) {
                        props.ref(input);
                    }
                }}
                {...props}
            />
        </FormControl>
    );
};

const WorkItemSearchFieldResource = (props: IWorkItemSearchFieldResourceProps) => {    
    const [value, setValue] = useState<string | GetAutocompleteResult | null>(null);
    return (
        <>
            <Box>
                <Autocomplete
                    sx={{'& #free-solo-with-text-demo': {padding: '3px 4px 7.5px 5px !important'}}}
                    value={value}
                    onChange={(event: any, newValue: string | GetAutocompleteResult | null) => {
                        props.onChange(event, newValue);
                        setValue(newValue);
                        if (props.mode === BulkUpdateModes.Resources && newValue === null) {
                            props.onChangeIsPrimaryCheckbox && props.onChangeIsPrimaryCheckbox(false);
                        }
                    }}
                    onKeyUp={props.onKeyUp}
                    handleHomeEndKeys
                    noOptionsText="No resources found"
                    id={"search-resources-"+props.idSuffix}
                    options={props.resources ?? [{ fullName: 'No resources found', userId: '0' }]}
                    getOptionLabel={(option) => {
                        if (typeof option === 'string') {
                            return option;
                        }
                        else {
                            return option.fullName;
                        }
                    }}
                    renderOption={props.loadingResources ? (props, option) => <li><CircularProgress /></li> : (props, option) => <li {...props}>{(option as GetAutocompleteResult).fullName}</li>}
                    freeSolo
                    renderInput={(params) => (
                        <ForwardWorkItemInputField  {...params} labelText={props.label} labelProps={props.labelProps} />
                    )}
                />
            </Box>
            {props.mode === BulkUpdateModes.Resources && value && <Box
                sx={{ paddingLeft: '8px' }}>
                <FormControlLabel
                    control={<Checkbox
                        checked={props.isPrimaryChecked}  // Controlled by the state
                        onChange={(e) => props.onChangeIsPrimaryCheckbox && props.onChangeIsPrimaryCheckbox(e.target.checked)}
                    />}
                    label='Match as Primary' />
            </Box>
            }
        </>
    );
}


export default WorkItemSearchFieldResource;